export const ToolbarButton = {
  button: {
    display: 'flex',
  },
};
